import { Start as Start_Start } from './Web Client/Start/Start.component';
import { MenuOpcoes as Menu_Opcoes_MenuOpcoes } from './Web Client/Menu Opcoes/MenuOpcoes.component';
import { TelaCriarOSCIGAMeMAGIC as TelaCriarOSCIGAMeMAGIC_TelaCriarOSCIGAMeMAGIC } from './Web Client/TelaCriarOSCIGAMeMAGIC/TelaCriarOSCIGAMeMAGIC.component';
import { CriarOST2KSistema as Tela_CriarOST2K_Sistema_CriarOST2KSistema } from './Web Client/Tela CriarOST2K Sistema/CriarOST2KSistema.component';
import { TelaCriarOSCreateEcho as Tela_CriarOS_Create_Echo_TelaCriarOSCreateEcho } from './Web Client/Tela CriarOS Create Echo/TelaCriarOSCreateEcho.component';
import { TelaCriarOSLMS as Tela_Criar_OS_LMS_TelaCriarOSLMS } from './Web Client/Tela Criar OS LMS/TelaCriarOSLMS.component';
import { CriarOSLMSCurso as Tela_Criar_OS_LMS_CriarOSLMSCurso } from './Web Client/Tela Criar OS LMS/CriarOSLMSCurso.component';
import { CriarOSLMSUsuario as Tela_Criar_OS_LMS_CriarOSLMSUsuario } from './Web Client/Tela Criar OS LMS/CriarOSLMSUsuario.component';
import { CriarOSLMSTarefa as Tela_Criar_OS_LMS_CriarOSLMSTarefa } from './Web Client/Tela Criar OS LMS/CriarOSLMSTarefa.component';
import { CriarOSLMSUnidadeOrg as Tela_Criar_OS_LMS_CriarOSLMSUnidadeOrg } from './Web Client/Tela Criar OS LMS/CriarOSLMSUnidadeOrg.component';
import { CriarOSLMSModeloCurs as Tela_Criar_OS_LMS_CriarOSLMSModeloCurs } from './Web Client/Tela Criar OS LMS/CriarOSLMSModeloCurs.component';
import { CriarOSLMSInfra as Tela_Criar_OS_LMS_CriarOSLMSInfra } from './Web Client/Tela Criar OS LMS/CriarOSLMSInfra.component';
import { CriarOSLMSWebconf as Tela_Criar_OS_LMS_CriarOSLMSWebconf } from './Web Client/Tela Criar OS LMS/CriarOSLMSWebconf.component';
import { CriarOSLMSRelatorio as Tela_Criar_OS_LMS_CriarOSLMSRelatorio } from './Web Client/Tela Criar OS LMS/CriarOSLMSRelatorio.component';
import { CriarOSLMSIntegracao as Tela_Criar_OS_LMS_CriarOSLMSIntegracao } from './Web Client/Tela Criar OS LMS/CriarOSLMSIntegracao.component';
import { FinalizaOS as Finaliza_OS_FinalizaOS } from './Web Client/Finaliza OS/FinalizaOS.component';
import { PesquisaOS as PesquisaOS_PesquisaOS } from './Web Client/PesquisaOS/PesquisaOS.component';
import { MostraResultadoPesquisa as Mostra_Resultado_Pesquisa_MostraResultadoPesquisa } from './Web Client/Mostra Resultado Pesquisa/MostraResultadoPesquisa.component';
import { AtividadesdaOS as Atividades_da_OS_AtividadesdaOS } from './Web Client/Atividades da OS/AtividadesdaOS.component';
import { DetalhesAtividade as Atividades_da_OS_DetalhesAtividade_DetalhesAtividade } from './Web Client/Atividades da OS/DetalhesAtividade/DetalhesAtividade.component';
import { DetalheItemdaOS as Detalhe_Item_da_OS_DetalheItemdaOS } from './Web Client/Detalhe Item da OS/DetalheItemdaOS.component';
import { AlterarItem as Alterar_Item_AlterarItem } from './Web Client/Alterar Item/AlterarItem.component';
import { ConsultaAcompanhamento as Consulta_Acompanhamento_ConsultaAcompanhamento } from './Web Client/Consulta Acompanhamento/ConsultaAcompanhamento.component';
import { MostraAnexos as Consulta_Acompanhamento_Mostra_Anexos_MostraAnexos } from './Web Client/Consulta Acompanhamento/Mostra Anexos/MostraAnexos.component';
import { CriarAcompanhamento as Criar_Acompanhamento_CriarAcompanhamento } from './Web Client/Criar Acompanhamento/CriarAcompanhamento.component';
import { SelecioneaEmpresa as Sel_Empresa_SelecioneaEmpresa } from './Web Client/Sel-Empresa/SelecioneaEmpresa.component';
import { SelContato as Sel_Contato_SelContato } from './Web Client/Sel-Contato/SelContato.component';
import { SelModulo as Sel_Modulo_SelModulo } from './Web Client/Sel-Modulo/SelModulo.component';
import { SelecioneaEmpresa as Sel_AtividadeOS_SelecioneaEmpresa } from './Web Client/Sel-AtividadeOS/SelecioneaEmpresa.component';
import { SelDefeitoSolucao as SelDefeitoSolucao_SelDefeitoSolucao } from './Web Client/SelDefeitoSolucao/SelDefeitoSolucao.component';
import { SelProduto as Sel_Produto_SelProduto } from './Web Client/Sel-Produto/SelProduto.component';
import { SelSituacao as Sel_Situação_SelSituacao } from './Web Client/Sel-Situação/SelSituacao.component';
import { Login as Login_Login } from './Web Client/Login/Login.component';
import { LoginInvalido as LoginInvalido_LoginInvalido } from './Web Client/LoginInvalido/LoginInvalido.component';
import { FileTransferSample as FileTransferSample_FileTransferSample } from './Web Client/FileTransferSample/FileTransferSample.component';
import { AguardandoServer as Login_AguardandoServer_AguardandoServer } from './Web Client/Login/AguardandoServer/AguardandoServer.component';
import { AguardandoCriandoOS as AguardandoCriandoOS_AguardandoCriandoOS } from './Web Client/AguardandoCriandoOS/AguardandoCriandoOS.component';
import { Logout as Logout_Logout } from './Web Client/Logout/Logout.component';
import { MostraEmpresasControladas as MostraEmpresasControladas_MostraEmpresasControladas } from './Web Client/MostraEmpresasControladas/MostraEmpresasControladas.component';
import { AtualizaSenhaUsuario as AtualizaSenhaUsuario_AtualizaSenhaUsuario } from './Web Client/AtualizaSenhaUsuario/AtualizaSenhaUsuario.component';

export const title = "";

export const magicGenCmpsHash = {               AtualizaSenhaUsuario_AtualizaSenhaUsuario:AtualizaSenhaUsuario_AtualizaSenhaUsuario,
                      MostraEmpresasControladas_MostraEmpresasControladas:MostraEmpresasControladas_MostraEmpresasControladas,
					  Logout_Logout:Logout_Logout,
                      AguardandoCriandoOS_AguardandoCriandoOS:AguardandoCriandoOS_AguardandoCriandoOS,
                      Login_AguardandoServer_AguardandoServer:Login_AguardandoServer_AguardandoServer,
                      FileTransferSample_FileTransferSample:FileTransferSample_FileTransferSample,
                      Start_Start:Start_Start,
              Menu_Opcoes_MenuOpcoes:Menu_Opcoes_MenuOpcoes,
              TelaCriarOSCIGAMeMAGIC_TelaCriarOSCIGAMeMAGIC:TelaCriarOSCIGAMeMAGIC_TelaCriarOSCIGAMeMAGIC,
              Tela_CriarOST2K_Sistema_CriarOST2KSistema:Tela_CriarOST2K_Sistema_CriarOST2KSistema,
              Tela_CriarOS_Create_Echo_TelaCriarOSCreateEcho:Tela_CriarOS_Create_Echo_TelaCriarOSCreateEcho,
              Tela_Criar_OS_LMS_TelaCriarOSLMS:Tela_Criar_OS_LMS_TelaCriarOSLMS,
              Tela_Criar_OS_LMS_CriarOSLMSCurso:Tela_Criar_OS_LMS_CriarOSLMSCurso,
              Tela_Criar_OS_LMS_CriarOSLMSUsuario:Tela_Criar_OS_LMS_CriarOSLMSUsuario,
              Tela_Criar_OS_LMS_CriarOSLMSTarefa:Tela_Criar_OS_LMS_CriarOSLMSTarefa,
              Tela_Criar_OS_LMS_CriarOSLMSUnidadeOrg:Tela_Criar_OS_LMS_CriarOSLMSUnidadeOrg,
              Tela_Criar_OS_LMS_CriarOSLMSModeloCurs:Tela_Criar_OS_LMS_CriarOSLMSModeloCurs,
              Tela_Criar_OS_LMS_CriarOSLMSInfra:Tela_Criar_OS_LMS_CriarOSLMSInfra,
              Tela_Criar_OS_LMS_CriarOSLMSWebconf:Tela_Criar_OS_LMS_CriarOSLMSWebconf,
              Tela_Criar_OS_LMS_CriarOSLMSRelatorio:Tela_Criar_OS_LMS_CriarOSLMSRelatorio,
              Tela_Criar_OS_LMS_CriarOSLMSIntegracao:Tela_Criar_OS_LMS_CriarOSLMSIntegracao,
              Finaliza_OS_FinalizaOS:Finaliza_OS_FinalizaOS,
              PesquisaOS_PesquisaOS:PesquisaOS_PesquisaOS,
              Mostra_Resultado_Pesquisa_MostraResultadoPesquisa:Mostra_Resultado_Pesquisa_MostraResultadoPesquisa,
              Atividades_da_OS_AtividadesdaOS:Atividades_da_OS_AtividadesdaOS,
              Atividades_da_OS_DetalhesAtividade_DetalhesAtividade:Atividades_da_OS_DetalhesAtividade_DetalhesAtividade,
              Detalhe_Item_da_OS_DetalheItemdaOS:Detalhe_Item_da_OS_DetalheItemdaOS,
              Alterar_Item_AlterarItem:Alterar_Item_AlterarItem,
              Consulta_Acompanhamento_ConsultaAcompanhamento:Consulta_Acompanhamento_ConsultaAcompanhamento,
              Consulta_Acompanhamento_Mostra_Anexos_MostraAnexos:Consulta_Acompanhamento_Mostra_Anexos_MostraAnexos,
              Criar_Acompanhamento_CriarAcompanhamento:Criar_Acompanhamento_CriarAcompanhamento,
              Sel_Empresa_SelecioneaEmpresa:Sel_Empresa_SelecioneaEmpresa,
              Sel_Contato_SelContato:Sel_Contato_SelContato,
              Sel_Modulo_SelModulo:Sel_Modulo_SelModulo,
              Sel_AtividadeOS_SelecioneaEmpresa:Sel_AtividadeOS_SelecioneaEmpresa,
              SelDefeitoSolucao_SelDefeitoSolucao:SelDefeitoSolucao_SelDefeitoSolucao,
              Sel_Produto_SelProduto:Sel_Produto_SelProduto,
              Sel_Situação_SelSituacao:Sel_Situação_SelSituacao,
              Login_Login:Login_Login,
              LoginInvalido_LoginInvalido:LoginInvalido_LoginInvalido,
       
};

export const magicGenComponents = [ AtualizaSenhaUsuario_AtualizaSenhaUsuario ,  MostraEmpresasControladas_MostraEmpresasControladas ,
Logout_Logout ,  
AguardandoCriandoOS_AguardandoCriandoOS ,  
Login_AguardandoServer_AguardandoServer ,  
FileTransferSample_FileTransferSample ,  
Start_Start,
Menu_Opcoes_MenuOpcoes,
TelaCriarOSCIGAMeMAGIC_TelaCriarOSCIGAMeMAGIC,
Tela_CriarOST2K_Sistema_CriarOST2KSistema,
Tela_CriarOS_Create_Echo_TelaCriarOSCreateEcho,
Tela_Criar_OS_LMS_TelaCriarOSLMS,
Tela_Criar_OS_LMS_CriarOSLMSCurso,
Tela_Criar_OS_LMS_CriarOSLMSUsuario,
Tela_Criar_OS_LMS_CriarOSLMSTarefa,
Tela_Criar_OS_LMS_CriarOSLMSUnidadeOrg,
Tela_Criar_OS_LMS_CriarOSLMSModeloCurs,
Tela_Criar_OS_LMS_CriarOSLMSInfra,
Tela_Criar_OS_LMS_CriarOSLMSWebconf,
Tela_Criar_OS_LMS_CriarOSLMSRelatorio,
Tela_Criar_OS_LMS_CriarOSLMSIntegracao,
Finaliza_OS_FinalizaOS,
PesquisaOS_PesquisaOS,
Mostra_Resultado_Pesquisa_MostraResultadoPesquisa,
Atividades_da_OS_AtividadesdaOS,
Atividades_da_OS_DetalhesAtividade_DetalhesAtividade,
Detalhe_Item_da_OS_DetalheItemdaOS,
Alterar_Item_AlterarItem,
Consulta_Acompanhamento_ConsultaAcompanhamento,
Consulta_Acompanhamento_Mostra_Anexos_MostraAnexos,
Criar_Acompanhamento_CriarAcompanhamento,
Sel_Empresa_SelecioneaEmpresa,
Sel_Contato_SelContato,
Sel_Modulo_SelModulo,
Sel_AtividadeOS_SelecioneaEmpresa,
SelDefeitoSolucao_SelDefeitoSolucao,
Sel_Produto_SelProduto,
Sel_Situação_SelSituacao,
Login_Login,
LoginInvalido_LoginInvalido 
];
